import "mmenu-js/src/mmenu";
import "mmenu-js/src/mmenu.scss";

const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
svg.setAttribute("width", "17");
svg.setAttribute("height", "11");
svg.setAttribute("viewBox", "0 0 17 11");
svg.setAttribute("fill", "none");

const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
path.setAttribute("d", "M16 9.81934L8.36161 2.18094L0.723215 9.81934");
path.setAttribute("stroke", "#181718");
path.setAttribute("stroke-width", "2.01786");
path.setAttribute("fill", "none");

svg.appendChild(path);

const button = document.createElement("button");
button.classList.add("submenu-button", "ms-auto");
button.appendChild(svg);

document.addEventListener("DOMContentLoaded", () => {
  const desktopSubMenu = document.querySelectorAll(".mega-menu .sub-menu");

  desktopSubMenu.forEach((submenu) => {
    const listItems = submenu.querySelectorAll("li");
    const numberOfItems = listItems.length;

    if (numberOfItems > 9) {
      submenu.classList.add("sub-menu-large");
    }
  });

  const menuWithChildren = document.querySelectorAll(".menu-item-has-children");

  menuWithChildren.forEach((menu) => {
    menu.addEventListener("mouseover", () => {
      const subMenu = menu.querySelector(".sub-menu");
      if (!subMenu) {
        return;
      }

      const rectMenu = menu.getBoundingClientRect();
      const rectSubMenu = subMenu.getBoundingClientRect();
      const left = rectMenu.left - rectSubMenu.left + rectMenu.width / 2;
      let styleSheet = document.querySelector("#dynamic-styles");
      if (!styleSheet) {
        styleSheet = document.createElement("style");
        styleSheet.id = "dynamic-styles";
        document.head.appendChild(styleSheet);
      }
      styleSheet.innerHTML = `
        .navbar .menu-desktop ul li .sub-menu:after {
          left: ${left}px;
        }
      `;
    });
  });

  if (document.querySelector("#menu")) {
    new Mmenu(
      "#menu",
      {
        extensions: ["theme-black", "fullscreen", "position-top"],
        navbars: {
          content: ["prev", "close"],
        },
        setSelected: {
          hover: true,
        },
        pageScroll: {
          scroll: true,
          update: true,
        },
      },
      {}
    );
  }

  const menuItemsWithSubmenu = document.querySelectorAll(
    ".mm-listview .menu-item-has-children"
  );
  menuItemsWithSubmenu.forEach((item) => {
    const clonedButton = button.cloneNode(true);
    item.querySelector("a").after(clonedButton);
    clonedButton.addEventListener("click", (event) => {
      const currentSubmenu = document.querySelector(".sub-menu.d-block");
      const currentButton = document.querySelector(".rotate");

      if (
        currentSubmenu &&
        currentSubmenu !== item.querySelector(".sub-menu")
      ) {
        currentSubmenu.classList.remove("d-block");
        currentButton.classList.remove("rotate");
      }

      if (!event.target.classList.contains("rotate")) {
        item.querySelector(".sub-menu").classList.add("d-block");
        event.target.classList.add("rotate");
      } else {
        item.querySelector(".sub-menu").classList.remove("d-block");
        event.target.classList.remove("rotate");
      }
    });
  });
});

let lastScrollTop = 0;
const menu = document.querySelector(".navbar-menu");
const wrapperPage = document.querySelector(".wrapper-page");

window.addEventListener("scroll", () => {
  if (!menu || !wrapperPage) {
    return;
  }

  let currentScroll = window.scrollY;

  if (currentScroll > lastScrollTop) {
    menu.classList.add("scrolled");
    wrapperPage.classList.add("scroll-wrapper");
  } else if (currentScroll === 0) {
    menu.classList.remove("scrolled");
    wrapperPage.classList.remove("scroll-wrapper");
  }

  lastScrollTop = currentScroll;
});
